import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Redirect, Route, RouteComponentProps, Switch, withRouter } from 'react-router-dom';
import { Modal, ModalBody } from 'reactstrap';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import Auth from 'src/Services/Auth';
import { UserStore } from 'src/Stores/User/UserStore';
import '../../styles/index.scss';
import Login from '../Login';
import Main from '../Main';

const auth = new Auth();

@inject('stores')
@observer
class App extends React.Component<RouteComponentProps> {
    public props: any;
    public UserStore: UserStore;
    constructor(props: any) {
        super(props);
        this.UserStore = this.props.stores.UserStore;
    }


    public render() {
        const token = auth.getToken();
        let logged = false;
        if (token && !auth.isTokenExpired(token))
        {
            logged = true;
        }
        return (
            <div className="App">
                <Switch>
                    <Route exact={true} path="/" component={Login} />
                    <Route path="/login" component={Login} />
                    {getLoggedRouteList(logged)}
                </Switch>
                <Modal isOpen={this.props.stores.loading} fade={false} centered={true} size={'sm'} modalTransition={{timeout: 0}} backdropTransition={{timeout: 0}}>
                    <ModalHeader>
                        Your Request Is Being Processed
                    </ModalHeader>
                    <ModalBody style={{textAlign: 'center'}}>
                        <FontAwesomeIcon 
                            icon={faSpinner}
                            spin={true}
                            size={"8x"}
                        />
                    </ModalBody>
                </Modal>
                <div id="my-hidden-div" />
            </div>
        );
    }
}

const renderRoute = (props: any) => {
    return (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: props.location },
        }}
      />
    );
};

const getLoggedRouteList = (logged: boolean) => {
    if (!logged) {
      return (
        <Route
          key="wait-login"
          render={renderRoute}
        />
      );
    }
  
    const output = [
        <Route key={1} path="/home/:list" component={Main} />,
        <Route key={2} path="/home" component={Main} />,
        <Route key={3} path="/profile" component={Main} />,
        <Route key={4} path='/admin/:task/:id' component={Main} />,
        <Route key={5} path='/admin' component={Main} />,
        <Route key={6} path='/approvals' component={Main} />,
        <Route key={7} path='/submissions' component={Main} />,
        <Route key={8} path='/reports' component={Main} />,
        <Route key={9} path='/dispatches' component={Main} />,
        <Route key={10} path='/activereports' component={Main} />,
        <Route key={11} path='/tableau/dispatchreport' component={Main} />,
        <Route key={11} path='/tableau/exceptionreport' component={Main} />,
        <Route key={11} path='/tableau/reports' component={Main} />,
        <Route key={11} path='/tableau/threeday' component={Main} />,
        <Route key={11} path='/tableau/recentrigactivity' component={Main} />,
        <Route key={11} path='/tableau/InventorySynopsis/InventorySynopsis' component={Main} />,
        <Route key={11} path='/tableau/ReturnedvsReceived/ReturnedvsReceivedSummary' component={Main} />,
        <Route key={11} path='/tableau/InventoryForecast/InventoryForecastReport' component={Main} />,
        <Route key={11} path='/tableau/HandoverReport/HandoverReport' component={Main} />,
        <Route key={11} path='/tableau/MissingDispatchTicketFiles/MissingDispatchFiles' component={Main} />,
        <Route key={12} path="/well/:wellId/:task/:taskId/:mainTask/:subTask" component={Main} />,
        <Route key={13} path="/well/:wellId/:task/:taskId/:mainTask" component={Main} />,
        <Route key={14} path="/well/:wellId/:task" component={Main} />,
        <Route key={15} path="/well/:wellId" component={Main} />,
        <Route key={16} path="/releasenotes" component={Main} />,
    ];
    return output;
};

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/Components/App/App.tsx